import React from "react";

type IState = {
	error:any;
	errorInfo: React.ErrorInfo | null;
}
export class ErrorBoundary extends React.Component {
	constructor(props: any) {
		super(props);
		this.state = { error: null, errorInfo: null };
	}

	state: IState = {
		error: null,
		errorInfo: null
	}

	componentDidCatch(error: any, errorInfo: React.ErrorInfo) {
		// Catch errors in any components below and re-render with error message
		this.setState({
			error: error,
			errorInfo: errorInfo
		})
		// You can also log error messages to an error reporting service here
	}

	render() {
		const errorInfo = this.state.errorInfo;
		if (errorInfo) {
			// Error path
			return (
				<div>
					<h2>Something went wrong.</h2>
					<details style={{ whiteSpace: 'pre-wrap' }}>
						{this.state.error && this.state.error.toString()}
						<br />
						{errorInfo.componentStack}
					</details>
				</div>
			);
		}
		// Normally, just render children
		return (this.props as any).children;
	}
}
